import { useEffect } from "react";
import { createChat } from "@n8n/chat";
import "@n8n/chat/style.css";

// Website lead-qualification chatbot, backed by the n8n workflow
// "Kurpfalz-Website-LeadBot". Answers FAQ questions and, once a visitor is
// qualified (name/e-mail/anliegen), hands the lead to Airtable + Telegram
// via a tool sub-workflow.
const CHAT_WEBHOOK_URL =
  "https://ck-partners.app.n8n.cloud/webhook/b82c5756-7a30-4c57-b692-575c060a314c/chat";

export const ChatWidget = () => {
  useEffect(() => {
    createChat({
      webhookUrl: CHAT_WEBHOOK_URL,
      mode: "window",
      showWelcomeScreen: false,
      defaultLanguage: "en",
      enableStreaming: true,
      initialMessages: [
        "Willkommen bei Kurpfalz Automation! Wie kann ich Ihnen weiterhelfen?",
      ],
      i18n: {
        en: {
          title: "Kurpfalz Automation",
          subtitle: "Wir antworten in der Regel innerhalb weniger Minuten.",
          footer: "",
          getStarted: "Neue Unterhaltung",
          inputPlaceholder: "Ihre Frage an uns...",
          closeButtonTooltip: "Chat schließen",
        },
      },
    });
  }, []);

  return null;
};

export default ChatWidget;
